import { axiosInstance } from "../axios";
import { MigrateFile, RequestResponse } from "../types";

export const uploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append("oldKmsKeys", file);

  try {
    const response = await axiosInstance.post(
      "/old-kms-keys/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
    return {
      error: false,
      message: response.data.responseMessage
    };
  } catch (error: any) {
    return {
      error: true,
      message:
        error.response?.data?.responseMessage ||
        "An error occurred while uploading the file"
    };
  }
};

export const getHistory: (
  page: number,
  pageSize: number,
  startDate: string,
  endDate: string,
  actor?: string
) => Promise<RequestResponse<{ records: MigrateFile[]; total: number }>> =
  async (page, pageSize, startDate, endDate, actor) => {
    try {
      const response = await axiosInstance.get(`/migration-history`, {
        params: {
          page,
          pageSize,
          startDate,
          endDate,
          ...(actor ? { actor } : {})
        }
      });

      return {
        error: false,
        data: {
          total: response.data.count,
          records: response.data.content
        }
      };
    } catch (err: any) {
      console.error("Unable to fetch migration history: ", err);
      return {
        error: true,
        data: null,
        message: err.response?.data?.responseMessage || err.message
      };
    }
  };
